export class YesNoCommentBlock {
    Yes: boolean;
    Comment: string;
}
